import {
  UserOutlined,
  MenuOutlined,
  ApiOutlined,
  BankOutlined,
  ShareAltOutlined,
  SettingOutlined,
  DownOutlined,
  ClusterOutlined,
  AppstoreOutlined,
  LaptopOutlined,
  SolutionOutlined,
  TeamOutlined,
  PieChartOutlined,
} from "@ant-design/icons";
import { Dropdown, MenuProps, Space } from "antd";
import store from "../../../../controllers/store";
import { ActionShowModalPreferences } from "../../../../controllers/store/actions/preferences/preferences-modal-actions";
import { Actor } from "../../..";

interface Props {
  user: any;
  commonsEntities: [];
  commonsCapacities: [];
}
const dispatch = store.dispatch;
const KnowledgeConsumerMenu = (Props: Props) => {
  const KnowledgeConsumer: MenuProps["items"] = [
    {
      label: "Perfil",
      key: "1",
      icon: <UserOutlined />,
      onClick: () => {
        window.location.href = "/profile";
      },
    },
    {
      label: "Empresa",
      key: "2",
      icon: <BankOutlined />,
      onClick: () => {
        window.location.href = "/entities?actortype=entities";
      },
    },
    {
      label: "Instituciones",
      key: "3",
      icon: <LaptopOutlined />,
      onClick: () => {
        window.location.href = "/entities?actortype=universities";
      },
    },
    {
      label: "Investigadores",
      key: "4",
      icon: <SolutionOutlined />,
      onClick: () => {
        window.location.href = "/entities?actortype=searchers";
      },
    },
    {
      label: "Grupos de investigación",
      key: "5",
      icon: <TeamOutlined />,
      onClick: () => {
        window.location.href = "/entities?actortype=groups";
      },
    },
    {
      label: "Otras Entidades",
      key: "6",
      icon: <ClusterOutlined />,
      children: Props.commonsEntities
        .filter((c: any) => c.collection_name === Actor.Commons)
        .map((c: any, index) => ({
          label: c.actor,
          key: `6-${index}`,
          onClick: () => {
            window.location.href = `/entities?commonstype=${c.id}`;
          },
        })),
    },
    {
      label: "Productos",
      key: "7",
      icon: <AppstoreOutlined />,
      onClick: () => {
        window.location.href = "/capacities?capacitytype=products";
      },
    },
    {
      label: "Proyectos",
      key: "8",
      icon: <ShareAltOutlined />,
      onClick: () => {
        window.location.href = "/capacities?capacitytype=projects";
      },
    },
    {
      label: "Otras capacidades",
      key: "9",
      icon: <ClusterOutlined />,
      children: Props.commonsCapacities
        .filter((c: any) => c.collection_name === "commons_capacities")
        .map((c: any, index) => ({
          label: c.name,
          key: `9-${index}`,
          onClick: () => {
            window.location.href = `/capacities?commonscapacitytype=${c.id}`;
          },
        })),
    },
    {
      label: "Estadistcas",
      key: "10",
      icon: <PieChartOutlined />,
      onClick: () => {
        window.location.href = "/analytics";
      },
    },
    {
      label: "Preferencias",
      key: "11",
      icon: <SettingOutlined />,
      onClick: () => {
        dispatch(ActionShowModalPreferences());
      },
    },
    {
      label: "Cerrar sesión",
      key: "12",
      icon: <ApiOutlined />,
      danger: true,
      disabled: false,
      onClick: () => {
        localStorage.removeItem("user");
        localStorage.removeItem("jwt");
        window.location.href = "/login";
      },
    },
  ];
  const menuProps = {
    items: KnowledgeConsumer,
    onClick: () => {},
  };

  const Menu: React.FC = () => {
    return (
      <a href="#" onClick={(e) => e.preventDefault()}>
        <svg viewBox="0 0 100 80" width="25" height="25">
          <rect fill="#ff974d" width="100" height="20"></rect>
          <rect fill="#ff974d" y="30" width="100" height="20"></rect>
          <rect fill="#ff974d" y="60" width="100" height="20"></rect>
        </svg>
      </a>
    );
  };

  return (
    <Dropdown.Button
      type="link"
      icon={<Menu />}
      menu={menuProps}
      onClick={() => {}}
    >
      {`${Props.user.me.first_name}`}
    </Dropdown.Button>
  );
};

export default KnowledgeConsumerMenu;
